import * as types from './types';
import { get } from 'lodash';
import { fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';
import { getCurrentTimeStamp } from '../api/dateFormat';
export function onRegularExamResponse(response) {
  return {
    type: types.REGULAR_EXAM_RESPONSE,
    response,
  };
}
export function enableLoader() {
  return {
    type: types.LOGIN_ENABLE_LOADER,
  };
}

export function disableLoader() {
  return {
    type: types.LOGIN_DISABLE_LOADER,
  };
}

export const examCalendarList = async (jwtToken, dispatch) => {
  const body = {};
  const url = 'api/studentexamcalendar';
  dispatch(enableLoader());
  await fetchPost(url, body, jwtToken)
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' })
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          })
        );
        return dispatch(logOut());
      }
      data['timestamp'] = getCurrentTimeStamp();
      dispatch(onRegularExamResponse(data));
      return dispatch(disableLoader());
    });
};
